export enum LabelType {
    OFFER = 1,
    PROMO = 2,
    OFFERGROUP = 3
}